import React from "react";
import SuggestedFollows from "../../components/SuggestedFollow";
import LatestNews from "../../components/LatestNews";
import NotificationsList from "../../components/notifications";


function Notification() {
  return (
    <div className="right-panel-inner">
        <div className="post-section">
            <h2 className="mb-20">Notifications</h2>
            <NotificationsList/>
        </div>
        <div className="right-side-bar">
          <SuggestedFollows/>
          <LatestNews/>
        </div>
    </div>
  );
}

export default Notification;